export enum CoverEvents {
  NAVIGATE = 'NAVIGATE',
}
